import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { VXSManagerV2ABI } from "./abi/VXSManagerV2ABI";

export class VXStrategyBotConfig{
    public swapMaxSlippageIndex:string;
    public swapFrequencySeconds:number;
    public splitFrequencySeconds:number;
    public splitMinProfitAmount:string;
    public maxGasAmount:string;
}

export class VXStrategyScope{

    public static readonly ZeroAddress = "0x0000000000000000000000000000000000000000";
    public static NewEmpty():VXStrategyScope
    {
        const scope = new VXStrategyScope();
        scope.rateUPLS=scope.uPLSInStake=scope.PLSToSwap=scope.lastSplitTimestamp=
        scope.swapMinPLSAmount=scope.swapMaxPLSAmount=scope.sendPLSIndex=scope.bnsIndex="0";
        scope.swapRouterV2=scope.sendPLSReceiver=scope.sendAddress=VXStrategyScope.ZeroAddress;
        scope.swapPath=[];
        scope.isBurnWithERC20Burn=false;
        return scope;
    }

    public rateUPLS:string;
    public uPLSInStake:string;
    public PLSToSwap:string;
    public lastSplitTimestamp:string;

    public swapRouterV2:string;
    public swapPath:string[];
    public swapMinPLSAmount:string;
    public swapMaxPLSAmount:string;

    public sendPLSIndex:string;
    public sendPLSReceiver:string;

    public bnsIndex:string;
    public sendAddress:string;

    public isBurnWithERC20Burn:boolean;
}

export class VXStrategyInfo{
    public owner_:string;
    public version_:string;
    public scope_:VXStrategyScope;
    public upls_:string;
    public pls_:string;
    public withdrawalPLS_:string;
}

export class VXSManagerV2Contract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, VXSManagerV2ABI.GetABI(), provider);
    }

    async configureBotAsync(config:VXStrategyBotConfig): Promise<boolean>
    {
        const result = await this._send('configureBot', 
            [
                this._toWei(config.swapMaxSlippageIndex), 
                config.swapFrequencySeconds+"",
                config.splitFrequencySeconds+"", 
                this._toWei(config.splitMinProfitAmount), 
                this._toWei(config.maxGasAmount)
            ]
            ); 
        return result;
    }

    async configureAsync(scope:VXStrategyScope, migration:boolean): Promise<boolean>
    {
        const _scope = [
            "0",
            this._toWei(scope.uPLSInStake),
            "0",
            "0",

            scope.swapRouterV2,
            scope.swapPath,
            this._toWei(scope.swapMinPLSAmount),
            this._toWei(scope.swapMaxPLSAmount),

            this._toWei(scope.sendPLSIndex),
            scope.sendPLSReceiver,

            this._toWei(scope.bnsIndex),
            scope.sendAddress,

            scope.isBurnWithERC20Burn
        ];
        
        if (migration)
        {
            _scope[0] = this._toWei(scope.rateUPLS);
            _scope[2] = this._toWei(scope.PLSToSwap);
            _scope[3] = scope.lastSplitTimestamp;
        } 
        const result = await this._send('configure', _scope, migration); 
        return result;
    }
    
    async withdrawUPLS(uPLSAmountETH:string): Promise<boolean>
    {
        const result = await this._send('withdrawUPLS', this._toWei(uPLSAmountETH)); 
        return result;
    }

    async withdrawPLS(): Promise<boolean>
    {
        const result = await this._send('withdrawPLS'); 
        return result;
    }
    
    async getStrategyAdr(ownerAdr:string): Promise<string>
    {
        return this._call("getStrategyAdr", ownerAdr);
    }
    
    async getFeed(strategyAdr:string): Promise<string>
    {
        const result = await this._call("getFeed", strategyAdr);
        return this._toDecimal(result);
    }

    async getStrategy(strategyAdr:string): Promise<VXStrategyInfo>
    {
        let result = await this._call("getStrategy", strategyAdr);
        if (!result) return;


        result.scope_.rateUPLS = this._toDecimal(result.scope_.rateUPLS);
        result.scope_.uPLSInStake = this._toDecimal(result.scope_.uPLSInStake);
        result.scope_.PLSToSwap = this._toDecimal(result.scope_.PLSToSwap);
        result.scope_.lastSplitTimestamp = result.scope_.lastSplitTimestamp;

        result.scope_.swapMinPLSAmount = this._toDecimal(result.scope_.swapMinPLSAmount);
        result.scope_.swapMaxPLSAmount = this._toDecimal(result.scope_.swapMaxPLSAmount);

        result.scope_.sendPLSIndex = this._toDecimal(result.scope_.sendPLSIndex);
        result.scope_.bnsIndex = this._toDecimal(result.scope_.bnsIndex);
        return result;
    }
}